import { render, staticRenderFns } from "./mechantScreenDetail.vue?vue&type=template&id=2a73b931&scoped=true&"
import script from "./mechantScreenDetail.vue?vue&type=script&lang=js&"
export * from "./mechantScreenDetail.vue?vue&type=script&lang=js&"
import style0 from "./mechantScreenDetail.vue?vue&type=style&index=0&id=2a73b931&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a73b931",
  null
  
)

export default component.exports